// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./js/a-i-search/" + {"53471":"a-i-search.image-upload-search.plugin.ts","96632":"a-i-search.natural-language-search.plugin.ts"}[chunkId] + "." + {"53471":"f3b9ba","96632":"43d423"}[chunkId] + ".js";
};